export default function TypeURL({ value }) {
  return <div>{value}</div>
}
